<template>
  <div v-click-outside="closeDropdown" class="like-menu">
    <div class="default-text" v-if="defaultText">{{ defaultText }}</div>
    <div class="categories options ">
      <div
        v-for="(item, index) in reduceList"
        :key="index"
        class="option"
        :class="{ active: item === selected }"
        @click="setOption(item)"
      >
        <div class="wrapp-img">
          <img
            v-if="item === selected"
            src="@/assets/newImges/icons/check-mark.svg"
            alt=""
          />
        </div>

        {{ typeof item === "object" && item !== null ? item.label : item }}
      </div>
    </div>
    <div v-if="showMore" class="show-more">
      <div v-if="!open" @click="open = true">
        <svg
          class="icon"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.76923 0.769231C5.76923 0.34375 5.42548 0 5 0C4.57452 0 4.23077 0.34375 4.23077 0.769231V4.23077H0.769231C0.34375 4.23077 0 4.57452 0 5C0 5.42548 0.34375 5.76923 0.769231 5.76923H4.23077V9.23077C4.23077 9.65625 4.57452 10 5 10C5.42548 10 5.76923 9.65625 5.76923 9.23077V5.76923H9.23077C9.65625 5.76923 10 5.42548 10 5C10 4.57452 9.65625 4.23077 9.23077 4.23077H5.76923V0.769231Z"
            fill="#CACDD0"
          />
        </svg>
        {{ $t("berza.showMore") }}
      </div>
      <div v-else @click="open = false">
        <svg
          class="icon icon1"
          width="11"
          height="2"
          viewBox="0 0 11 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L9.3 1"
            stroke="#CACDD0"
            stroke-width="1.55"
            stroke-linecap="round"
          />
        </svg>
        {{ $t("berza.viewLess") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "likeMenu",
  props: {
    list: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    selected: {
      required: false
    },
    defaultText: {
      type: String,
      required: false
    },
    showNumElement: {
      type: Number,
      required: false,
      default: 4
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    remove(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit("remove");
    },
    closeDropdown() {
      this.open = false;
    },

    setOption(option) {
      this.$emit("changeOption", option);
    }
  },
  computed: {
    // getSelected() {
    //   if (this.selected) {
    //     return typeof this.selected === "object" && this.selected !== null
    //       ? this.selected.label
    //       : this.selected;
    //   } else if (this.defaultText) {
    //     return this.defaultText;
    //   } else {
    //     return "Sort...";
    //   }
    // },
    showMore() {
      return this.list && this.list.length > this.showNumElement;
    },
    reduceList() {
      if (this.showMore && this.open) return this.list;
      return this.list.slice(0, this.showNumElement);
    }

    // filteredList() {
    //   if (this.search) {
    //     return this.list.filter(item => {
    //       return this.search
    //         .toLowerCase()
    //         .split(" ")
    //         .every(v => item.label.toLowerCase().includes(v));
    //     });
    //   } else {
    //     return this.list;
    //   }
    // }
  },
  watch: {
    // search: function(val) {
    //   this.$emit("search", val);
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/scrollbarStyles.scss";

.like-menu {
  margin-top: 32px;
  text-align: left;
  transition: 0.2s ease;
  .default-text {
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
    color: $blue-1000;
    margin-bottom: 20px;
  }
  .options {
    max-height: 200px;
    overflow: auto;
    // direction: rtl;
  }
  .option {
    // direction: ltr;
    display: flex;
    align-items: center;
    cursor: pointer;

    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0%;
    vertical-align: middle;
    transition: 0.2s ease;

    color: $blue-400;
    .wrapp-img {
      width: 16px;
      display: flex;
      margin-right: 4px;
    }
  }
  .option:hover {
    color: $blue-500;
  }
  .option.active {
    color: $blue-1000;
  }
}
.icon {
  margin-right: 3px;
}
.icon path {
  transition: fill 0.2s;
  transition: stroke 0.2s;
}

.show-more {
  margin-top: 10px;
  color: $gray-blue-1300;
  cursor: pointer;
  transition: all 0.2s;
}
.show-more > div {
  display: flex;

  align-items: center;
}
.show-more:hover {
  color: $blue-1000;
  .icon path {
    fill: $blue-1000; /* hover color */
  }
  .icon1 path {
    stroke: $blue-1000;
  }
}

@media only screen and (max-width: 767px) {
  .like-menu {
  }
}
</style>
